import React from 'react';

import { Space } from 'antd';
import moment from 'moment';

import IconFilter from '../IconFilter';
import { getStartEndType } from '../pickers/DateTimeRangePicker';

/** Маппинг типов пресетов к их русским названиям */
const PRESET_LABELS: Record<string, string> = {
    today: 'Сегодня',
    yesterday: 'Вчера',
    thisweek: 'Эта неделя',
    lastweek: 'Прошлая неделя',
    thismonth: 'Этот месяц',
    lastmonth: 'Прошлый месяц',
    thisquart: 'Этот квартал',
    lastquart: 'Прошлый квартал',
    thisyear: 'Этот год',
    lastyear: 'Прошлый год',
    last7days: 'Последние 7 дней',
    last14days: 'Последние 14 дней',
    last30days: 'Последние 30 дней',
    last365days: 'Последние 365 дней',
};

/** Формирует текст для ndaysago/nhoursago */
const getNRelativeLabel = (calendar: any): string | null => {
    if (calendar?.type === 'ndaysago') {
        const nStart = calendar.nStart ?? 0;
        const nEnd = calendar.nEnd ?? 0;
        if (calendar.nStartTime != null) {
            const sTime = calendar.nStartTime || '00:00';
            const eTime = calendar.nEndTime || '23:55';
            return `от ${nStart} с ${sTime} до ${nEnd} по ${eTime} дней назад`;
        }
        return `от ${nStart} до ${nEnd} дней назад`;
    }
    if (calendar?.type === 'nhoursago') {
        const nStart = calendar.nStart ?? 0;
        const nEnd = calendar.nEnd ?? 0;
        return `от ${nStart} до ${nEnd} часов назад`;
    }
    return null;
};

const DateTimeRangeView = ({ icon, name, start: _start, end: _end, calendar }: any) => {
    const presetLabel = calendar?.type ? PRESET_LABELS[calendar.type] : null;
    const nRelativeLabel = getNRelativeLabel(calendar);

    const renderContent = () => {
        if (presetLabel) {
            return <div>{presetLabel}</div>;
        }
        if (nRelativeLabel) {
            return <div>{nRelativeLabel}</div>;
        }

        const { start, end } = getStartEndType({ start: _start, end: _end, calendar });

        if (!start && !end) {
            return <div>Все время</div>;
        }

        const hasTime = calendar.type === 'nhoursago'
            || (calendar.type === 'ndaysago' && calendar.nStartTime != null)
            || calendar.time;
        const formatView = hasTime ? 'DD MMM YYYY HH:mm' : 'DD MMM YYYY';

        return (
            <>
                <div>
                    {start && moment(start).format('dd').toUpperCase()}&nbsp;{start && moment(start).format(formatView)}
                </div>
                <div style={{ opacity: 0.5 }}>—</div>
                <div>
                    {end && moment(end).format('dd').toUpperCase()}&nbsp;{end && moment(end).format(formatView)}
                </div>
            </>
        );
    };

    return (
        <Space size="small">
            <div>
                <IconFilter icon={icon} />
                &nbsp;{name}:
            </div>
            {renderContent()}
        </Space>
    );
};

export default DateTimeRangeView;
